<template>
  <pi-content className="white">
    <div class="charge-finish-draw-gun v-service">
      <div v-if="!showPayOrder">
        <div class="charge-finish-tag">充电结束</div>
        <div class="charge-finish-base-info">
          <div class="divider"></div>
          <div class="cell">
            <div class="cell-title">停止原因</div>
            <div class="cell-content">{{info.stopReasonDesc}}</div>
          </div>
          <div class="cell">
            <div class="cell-title">车牌号</div>
            <div class="cell-content">京C134343</div>
          </div>
        </div>
      </div>
      <div v-else class="unpaid">
        <div class="unpaid-tag">
            <img src="../../assets/img/ic_unpaid.png">
            <div class="unpaid-tag-text">未支付订单</div>
        </div>
        <div class="unpaid-table-title">
          <div class="charge-fare-sum">
            充电费用总计
          </div>
          <div class="details-info">
            详细信息
          </div>
        </div>
        <div class="unpaid-table-header">
          <div class="header-cell">
            订单号
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-title">
           电费(元)
          </div>
          <div class="content-title">
           服务费(元)
          </div>
          <div class="content-title">
            充电(度)
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-cell">
            123
          </div>
          <div class="content-cell">
            123
          </div>
          <div class="content-cell">
           123
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-title">
            延时费(元)
          </div>
          <div class="content-title">
            延时时长(分钟)
          </div>
          <div class="content-title">
            充电时长(分钟)
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-cell">
            123
          </div>
          <div class="content-cell">
            123
          </div>
          <div class="content-cell">
           123
          </div>
        </div>
        <div class="unpaid-table-content-line">
          <div class="content-title">
            停止原因
          </div>
          <div class="content-cell">

          </div>
        </div>
        <div class="unpaid-table-content-line">
          <div class="content-title">
            车牌号
          </div>
          <div class="content-cell">

          </div>
        </div>
      </div>

      <div class="money" v-if="showPayOrder">
        合计:
        <span class="value">{{info.totalAmount}}元</span>
      </div>
      <div v-if="!drawGun">
        <div style="text-align: center; font-size: 0.32rem; color: #333333; font-weight: 500; padding-top: 0.2rem">等待拔枪，当前正在计算占桩费用</div>
        <div class="button1 enable">
          未拔枪
        </div>
      </div>
      <div v-else class="button1" @click="doPay">
        {{drawGun? '已拔枪，去结算' : '结算'}}
      </div>
      <div class="info">
        <div class="info-name">电价信息</div>
        <div class="info-content" v-for="(item, index) in info.chargeFeePrice" :key="index">
          <div class="info-content-container">
            <div class="tag">时段</div>
            <div class="value">{{item.beginTime}}-{{item.endTime}}</div>
          </div>
          <div class="info-content-container">
            <div class="tag">充电费(度)</div>
            <div class="value">{{item.slotElecPrice}} 元</div>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="info-name">延时费信息</div>
        <div class="info-content" v-for="(item, index) in info.delayFeePrice" :key="index">
          <div class="info-content-container">
            <div class="tag">时段</div>
            <div class="value">{{item.beginTime}}-{{item.endTime}}</div>
          </div>
          <div class="info-content-container">
            <div class="tag">延时费率(分钟)</div>
            <div class="value">{{item.slotDelayPrice}} 元</div>
          </div>
        </div>
      </div>
    </div>
  </pi-content>
</template>

<script>
// import { settleAccountInfo, settleAccount } from '@/common/api/index';  
import { Button, RadioGroup, Radio, Cell, CellGroup } from 'vant';
export default {
  name: 'change-success',
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      radio: '1',
      drawGun: true, // 是否已拔枪
      showPayOrder: true, // 显示支付订单
      info: {
        chargeFeePrice: [],
        delayFeePrice: []
      }
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    timeFnGetInfo () {
      setTimeout(() => {
        this.getInfo();
      }, 3000);
    },
    getInfo() {
      // settleAccountInfo({
      //   orderNo: '123'
      // }, 'no').then((data) => {
      //   if (data.status === this.$config.ajaxStatus2) {
      //     this.info = data.data[0];
      //     this.timeFnGetInfo();
      //   } else {
      //     throw new Error(data.status);
      //   }
      // }).catch((error) => {
      //   console.log(error);
      //   this.timeFnGetInfo();
      // });
    },
    doPay() {
      if (!this.showPayOrder) {
        this.showPayOrder = true;
        return;
      }
      // settleAccount({
      //   orderNo: '123'
      // }).then((data) => {
      //   if (data.status === this.$config.ajaxStatus2) {
      //   }
      // }).catch((error) => {
      //   console.log(error);
      // });
    }
  }
};
</script>

<style lang="less" scoped>
  @primaryColor: #14cc80;
.divider{
  border-bottom: #D9D9D9 1px solid;
  margin: 0 0.2rem;
}
.charge-finish-draw-gun {
  .charge-finish-tag{
    font-size:0.36rem;
    color:rgba(51,51,51,1);
    text-align: center;
    padding: 0.72rem 0;
  }
}
.cell {
  position: relative;
  padding: 0.24rem 0.24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cell-title {
    color: #999999;
    min-width: 2rem;
  }
  .cell-content {
    color: #666666;
    flex: 1;
    width: 0;
    text-align: end;
  }
  &:after {
    position: absolute;
    left: 0.2rem;
    right: 0.2rem;
    bottom: 0;
    border-bottom: 1px solid #D9D9D9;
    opacity: .8;
    content: "";
  }
}
.button1 {
  height: 0.8rem;
  background:  @primaryColor;
  border-radius:40px;
  text-align: center;
  color: white;
  font-size: 0.34rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.4rem 0.8rem;
  &.enable {
    background:rgba(20,204,128,0.13);
    border:1px solid rgba(20,204,128,1);
    color: @primaryColor;
  }
}
.info{
  margin: 0 0.36rem;
  .info-name {
    color: #666666;
  }
  .info-content{
    background-color: #F8F4F5;
    display: flex;
    .info-content-container{
      flex: 1;
      padding: 0.11rem;
      .tag{
        color: #666666;
        text-align: center;
      }
      .value{
        color: #999999;
        margin-top: 0.14rem;
        text-align: center;
      }
    }
  }
}
.unpaid{
  .unpaid-tag{
    margin: 0.37rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.56rem;
      height: 0.56rem;
      font-size: 0.58rem;
    }
    .unpaid-tag-text {
      margin: 0 0.2rem;
      font-size: 0.42rem;
      color: @primaryColor;
    }
  }
  .unpaid-table-title {
    display: flex;
    justify-content: space-between;
    margin: 0.23rem 0.45rem;
    .charge-fare-sum {
      color: #999999;
      font-size: 0.28rem;
    }
    .details-info {
      color: #FF8F1F;
      font-size: 0.26rem;
    }
  }
  .unpaid-table-header{
    background-color: rgba(20,204,128,0.14);
    display: flex;
    margin: 0.23rem 0.24rem 0 0.24rem;
    .header-cell{
      color: #666666;
      font-size: 0.24rem;
      flex: 1;
      border-right: white 0.02rem solid;
      padding: 0.02rem 0.2rem;
      line-height: 0.4rem;
    }
  }
  .unpaid-table-content{
    background-color: #F8F4F5;
    display: flex;
    margin: 0 0.24rem 0.02rem 0.24rem;
    .content-title{
      color: #666666;
      font-size: 0.26rem;
      flex: 1;
      text-align: center;
      border-right: white 0.02rem solid;
      padding: 0.11rem 0;
    }
    .content-cell{
      color: #333333;
      font-size: 0.28rem;
      flex: 1;
      text-align: center;
      border-right: white 0.02rem solid;
      padding: 0.11rem 0;
    }
  }
  .unpaid-table-content-line{
    background-color: #F8F4F5;
    display: flex;
    margin: 0 0.24rem 0.02rem 0.24rem;
    justify-content: space-between;
    .content-title{
      color: #666666;
      font-size: 0.28rem;
      padding: 0.11rem 0.2rem;
    }
    .content-cell{
      color: #333333;
      font-size: 0.28rem;
      padding: 0.11rem 0.2rem;
    }
  }
}
.money {
  text-align: right;
  font-size: 0.28rem;
  color: #333333;
  font-weight: 500;
  padding: 0.2rem 0.2rem 0 0;
  span {
    font-size: 0.42rem;
    color: @primaryColor;
  }
}
</style>
